/**
 * Limites anti-banimento WhatsApp do motor de follow-up.
 * Fonte única para Edge (`process-followups`) e app (`followUp.constants` reexporta).
 */

export const DEFAULT_MIN_INTERVAL_SECONDS = 60;
export const DEFAULT_MAX_SENDS_PER_CYCLE = 5;

export const MIN_INTERVAL_SECONDS_MIN = 45;
export const MIN_INTERVAL_SECONDS_MAX = 300;
export const MAX_SENDS_PER_CYCLE_MIN = 1;
export const MAX_SENDS_PER_CYCLE_MAX = 10;

/** Clampa intervalo mínimo entre envios na mesma conexão. */
export function clampMinIntervalSeconds(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_MIN_INTERVAL_SECONDS;
  return Math.min(
    MIN_INTERVAL_SECONDS_MAX,
    Math.max(MIN_INTERVAL_SECONDS_MIN, Math.floor(value)),
  );
}

/** Clampa teto de envios por ciclo do cron. */
export function clampMaxSendsPerCycle(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_MAX_SENDS_PER_CYCLE;
  return Math.min(
    MAX_SENDS_PER_CYCLE_MAX,
    Math.max(MAX_SENDS_PER_CYCLE_MIN, Math.floor(value)),
  );
}
